/**
 * Route table.
 *
 * A flat map of path → page module. Each page module default-exports a render
 * function (see `./router.js` for the contract). Kept declarative and separate
 * from the router so the set of pages is readable at a glance.
 *
 * Every page is imported statically. The prototype is small, and static imports
 * keep type checking honest and avoid a loading state on navigation. If the
 * bundle grows, individual routes can move to dynamic import without changing the
 * router.
 */

import renderLanding from "../pages/landing.js";
import renderRetrieval from "../pages/retrieval.js";
import renderSignIn from "../pages/sign-in.js";
import renderRegister from "../pages/register.js";
import renderDashboard from "../pages/dashboard.js";
import renderCreateProfile from "../pages/create-profile.js";
import renderEditContacts from "../pages/edit-contacts.js";
import renderPricing from "../pages/pricing.js";
import renderAccount from "../pages/account.js";
import renderYourData from "../pages/your-data.js";
import renderPrivacy from "../pages/privacy.js";
import renderTerms from "../pages/terms.js";
import renderNotFound from "../pages/not-found.js";

/**
 * @typedef {object} RouteDefinition
 * @property {string} title The document title and page heading.
 * @property {import("./router.js").PageRenderer} render The page renderer.
 * @property {boolean} [requiresAuth] Whether an unauthenticated visitor is
 *   redirected to sign-in. Prototype-level gating only; the server enforces the
 *   real thing (CLAUDE.md).
 */

/** @type {Record<string, RouteDefinition>} */
export const routes = {
  "/": { title: "KinCode", render: renderLanding },
  "/retrieve": { title: "Retrieve contacts", render: renderRetrieval },
  "/sign-in": { title: "Sign in", render: renderSignIn },
  "/register": { title: "Create an account", render: renderRegister },
  "/dashboard": { title: "Your profiles", render: renderDashboard, requiresAuth: true },
  "/profiles/new": { title: "Create a profile", render: renderCreateProfile, requiresAuth: true },
  "/profiles/edit": { title: "Edit contacts", render: renderEditContacts, requiresAuth: true },
  "/pricing": { title: "Pricing", render: renderPricing },
  "/account": { title: "Account", render: renderAccount, requiresAuth: true },
  "/your-data": { title: "Your data", render: renderYourData, requiresAuth: true },
  "/privacy": { title: "Privacy", render: renderPrivacy },
  "/terms": { title: "Terms", render: renderTerms },
};

/** @type {RouteDefinition} */
export const notFoundRoute = { title: "Page not found", render: renderNotFound };
